import type { RectangleShape as RectangleShapeType } from '@/features/comment-on-file';
import { strokeWidthFor } from './strokeWidths';

interface Props {
  shape: RectangleShapeType;
  color: string;
  focused?: boolean;
  halo?: boolean;
}

export function RectangleShape({ shape, color, focused, halo }: Props) {
  const { x, y, w, h } = shape.rect;
  const nx = w < 0 ? x + w : x;
  const ny = h < 0 ? y + h : y;
  const nw = Math.abs(w);
  const nh = Math.abs(h);
  const strokeWidth = strokeWidthFor('rectangle', { focused, halo });
  return (
    <rect
      x={nx}
      y={ny}
      width={nw}
      height={nh}
      fill="transparent"
      stroke={color}
      strokeWidth={strokeWidth}
      vectorEffect="non-scaling-stroke"
    />
  );
}
